import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ContactStore, CONTACT_TYPE } from '@boxx/contacts-core';
import {
  EventModel,
  EventsStore,
  IEventDetailEmitter,
  ILocalNotificationsService,
  LOCAL_NOTIFICATIONS_SERVICE,
} from '@boxx/events-core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment_ from 'moment';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil, withLatestFrom } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { FirebaseAnalyticsService } from 'src/services/NativeFirebase/NativeFirebase.service';
import { PwaUtilsService } from 'src/services/pwaUtils.service';

const moment = moment_;

@Component({
  selector: 'app-event-detail',
  templateUrl: './event-detail.page.html',
  styleUrls: ['./event-detail.page.scss'],
})
export class EventDetailPage implements OnInit, OnDestroy {
  selectedEvent$: Observable<EventModel>;
  selectedEvent: EventModel;
  attendeesType: { contactId: number; type: CONTACT_TYPE }[];

  destroyed$ = new Subject<boolean>();
  monthNames = moment.months().toString();

  loader: HTMLIonLoadingElement;

  translations: any = {};
  loading$: Observable<boolean>;

  canSaveData = false;
  newEvent: EventModel;

  breakpointWidth: number;
  isDetailView = false;

  eventId: number;

  constructor(
    @Optional()
    @Inject(LOCAL_NOTIFICATIONS_SERVICE)
    private localNotifSrvc: ILocalNotificationsService,
    private router: Router,
    private route: ActivatedRoute,
    private eventsStore: EventsStore,
    private contactsStore: ContactStore,
    private translate: TranslateService,
    private firebaseService: FirebaseAnalyticsService,
    private boxxUtils: BoxxUtilsService,
    private pwaUtilsService: PwaUtilsService,
    public modalCtrl: ModalController
  ) {
    this.translate
      .get(['EVENTS_MODULE', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.isDetailView = event.url.indexOf('/detail') !== -1;
      });
  }

  ngOnInit() {
    this.selectedEvent$ = this.eventsStore.eventById$(
      +this.eventId
    );

    this.contactsStore.contacts.data$
      .pipe(withLatestFrom(this.selectedEvent$), takeUntil(this.destroyed$))
      .subscribe(([contactList, event]) => {
        if (event) {
          const newerEvent = EventModel.clone(event);
          newerEvent.attendees = event.attendees.map(
            (attendee) =>
              contactList.filter((contact) => contact.id === attendee.id)[0]
          );

          this.selectedEvent = newerEvent;
          this.selectedEvent.url = (this.selectedEvent.url !== null && this.selectedEvent.url !== 'null') ? this.selectedEvent.url : '';
        }
      });

    //this.handleLoading();
    this.handleSuccess();
    //this.handleError();

    this.firebaseService.setScreenName('EVENTS > DETAIL');
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ionViewWillEnter() {
    this.setPwaListener();
  }

  formChange(val: IEventDetailEmitter) {
    this.canSaveData = val.hasChanges;
    this.newEvent = val.data;
  }

  async confirmDelete() {
    this.boxxUtils.showAlert({
      header: this.translations.EVENTS_MODULE.deleteALERT.header,
      message: this.translations.EVENTS_MODULE.deleteALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
          role: 'cancel',
          cssClass: 'boxx-main-btn',
        },
        {
          text: this.translations.ACTIONS.ok,
          handler: () => {
            this.eventsStore.deleteEvent(
              +this.route.snapshot.paramMap.get('id')
            );
          },
        },
      ],
    });
  }

  updateEvent() {
    this.eventsStore.updateEvent(this.newEvent);
  }

  private handleSuccess() {
    this.eventsStore.success$
      .pipe(
        takeUntil(this.destroyed$),
        filter((success) => ['UPDATE', 'DELETE'].includes(success?.after))
      )
      .subscribe((success) => {
        // this.boxxUtils.showToastSuccess({
        //   message:
        //     this.translations.SUCCESS.EVENTS[success.after.toLowerCase()],
        // });

        if (success.after === 'DELETE' && this.localNotifSrvc) {
          this.localNotifSrvc.removeReminder(
            +this.route.snapshot.paramMap.get('id')
          );

          //this.router.navigateByUrl('/tabs/events');
          this.modalCtrl.dismiss();
        } else if (success.after === 'UPDATE') {
          //this.canSaveData = false;
          this.modalCtrl.dismiss();
        }
      });
  }

  // private handleError() {
  //   this.eventsStore.error$
  //     .pipe(
  //       takeUntil(this.destroyed$),
  //       filter((error) => ['UPDATE', 'DELETE'].includes(error?.after))
  //     )
  //     .subscribe((error) => {
  //       console.log('error: ', error);
  //       if(error.error && error.error.message){
  //         this.boxxUtils.showToastError({
  //           message: error.error.message
  //         });
  //         return;
  //       }
  //       this.boxxUtils.showToastError({
  //         message: this.translations.ERRORS.EVENTS[error.after.toLowerCase()],
  //       });
  //     });
  // }

  private setPwaListener() {
    this.breakpointWidth = this.pwaUtilsService.getBreakpointWidth();
    this.pwaUtilsService.reportWindowResize$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dimensions) => {
        if (dimensions.width >= this.breakpointWidth) {
          this.router.navigateByUrl('/tabs/events');
        }
      });
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
